



















































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    //import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import { classPrintWorld } from '@/common/js/PrintWorld'
    import UpdatebackadvanceStatu from '@/store/entities/back-updatestatus'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    import { Select } from '../../../types/iview/select';
    Vue.use(VueClipboard)


    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        SearchInfo: string;
        userCode: string;
        BeginTime?: Date;
        beginOrderPayTime?: Date;
        endOrderPayTime?: Date;
        whetherInputHandle?: string;
        site: number;
        exceedOrderPayTime: number;
        EndTime?: Date;
        PlatformType: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.site = 4;
            this.exceedOrderPayTime = 4;
            this.whetherInputHandle = "false";
            this.PlatformType = null;
        }
    }

    @Component({
        name: "backadvance",

    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        receivedTime: Date[] = [];
        orderPayTime: Date[] = [];
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        siteType = Enums.SiteSType.filter(function (item) { return item.value == 4 });
        whetherhandleList = Enums.getEnum(Enums.WhetherStringStatus, true);
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        updateOderStatuShow = false;
        editModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        automaticJump: boolean = true;
        isLoadPrintList: boolean = false;
        flag: boolean = false;
        isShow: boolean;
        baleStockOrderModal: boolean = false;
        orderNumberList: string[] = [];
        logisticsList: string[] = [];
        BaseSkuNums: number[] = [];
        idList: number[] = [];
        BaseDays: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        get list() {
            return this.$store.state.backadvance.list;
        };
        get loading() {
            return this.$store.state.backadvance.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backadvance/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backadvance/setPageSize', pagesize);
            this.getpage();
        }
        async exportexpress() {
            await this.$store.dispatch({
                type: 'backadvance/impotExcel',
                data: this.pagerequest
            })
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }
        handle() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.handlePost(ids);
        }

        Againhandle() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.againhandlePost(ids);
        }

        async handlePost(ids: any[]) {
            await this.$store.dispatch({
                type: 'backadvance/handleStatus',
                data: { ordereIds: ids }
            })
            this.searchPage();
        }

        async againhandlePost(ids: any[]) {
            await this.$store.dispatch({
                type: 'backadvance/againhandleStatus',
                data: { ordereIds: ids }
            })
            this.searchPage();
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (abp.session.userId == 218 || abp.session.userId == 198) {

            }
            else {
                this.storeaddressList.push(a);
            }

        }

        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            if (this.orderPayTime.length > 0) {
                this.pagerequest.beginOrderPayTime = this.orderPayTime[0];
            } else {
                this.pagerequest.beginOrderPayTime = null;
            }
            if (this.orderPayTime.length > 1) {
                this.pagerequest.endOrderPayTime = this.orderPayTime[1];
            } else {
                this.pagerequest.endOrderPayTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (!this.pagerequest.exceedOrderPayTime) {
                this.pagerequest.exceedOrderPayTime = 0;
            }
            await this.$store.dispatch({
                type: 'backadvance/getAll',
                data: this.pagerequest
            });
        }

        async searchPage() {
            this.$store.state.backadvance.currentPage = 1;
            this.getpage();
        }

        get pageSize() {
            return this.$store.state.backadvance.pageSize;
        }
        get totalCount() {
            return this.$store.state.backadvance.totalCount;
        }
        get currentPage() {
            return this.$store.state.backadvance.currentPage;
        }


        columns = [
            {
                type: 'selection',
                width: 60,
                align: 'center',

            },
            {
                title: '仓库名称',
                key: 'warehouseName',
                width: 150,
            },
            {
                title: '是否已处理',
                key: 'whetherInputHandle',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.whetherInputHandle ? "已处理" : "未处理");
                }
            },
            {
                title: '是否允许提前录入',
                key: 'whetherInputAllow',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.whetherInputAllow ? "允许" : "不允许");
                }
            },
            {
                title: '订单支付时间',
                key: 'orderPaymentTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.orderPaymentTime ? DateUtils.formatLongDate(new Date(params.row.orderPaymentTime)) : '');
                }
            },
            {
                title: '采购订单编号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        return h('li', {
                            domProps: {
                                innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                            }
                        });
                    }));
                }
            },
            {
                title: '用户编号',
                key: 'userCode',
                width: 90,
            },
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            },

            {
                title: '快递单号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        var productOrderStatusName = "";
                        if (params.row.productOrderStatus != null) {
                            productOrderStatusName = Enums.ProductOrderStatus.filter(function (dataItem) { return dataItem.value == params.row.productOrderStatus })[0].name;
                        }
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn || productOrderStatusName == "已取消" || packagestus == "已撤销") {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });
                    }));
                }
            },

            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                    }));
                }
            },
            {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            },
            {
                title: '产品订单状态',
                width: 110,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: 'red' } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            },


            {
                title: '时间',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "创建时间:" + (params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime)))), h('h3', "更新时间:" + (params.row.updateTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.updateTime)))), h('h3', "打包时间:" + (params.row.packedTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.packedTime)))), h('h3', "送仓时间:" + (params.row.arriveWarehouseTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime))))])
                }
            },

            {
                title: '操作',
                width: 120,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    this.copyInfo(params.row.orderNumber);
                                }
                            }
                        }, "复制订单号"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    this.copyInfo(params.row.tradeNo);
                                }
                            }

                        }, "复制运单号"),
                    ]);
                }
            }
        ]

        async created() {
            this.getData();
            this.getpage();

        }
        async mounted() {
        }
    }
